
import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import TabChange from './tabChange.vue'
import Empty from '@/components/Empty/index.vue'
import {
  getOrderDetailPage,
  queryOrderDetailById,
  orderCancel,
  orderReject,
  orderRefund,
  uploadShippingRetry,
  giftBucketsPreview,
  giftBucketsCreate,
} from '@/api/order'
import { canManualUploadShipping as checkCanManualUploadShipping } from '@/utils/wxShipping'
import { queryDishList } from '@/api/dish'
import { getCategoryList } from '@/api/category'
import {
  formatMoney,
  dishLineTotal,
  orderDishSubtotalFrom,
  orderQuotaDiscountFrom,
  orderDiscountLabel,
  hasOrderDiscount,
  payMethodLabel,
} from '@/utils/orderAmount'
import UserNameRemark from '@/components/UserNameRemark/index.vue'
import { formatOrderRemarkDisplay } from '@/utils/orderRemarkDisplay'
import { formatOrderBizType as resolveOrderBizType, isNonPaymentFulfillmentOrder } from '@/utils/orderBizType'
import {
  isApiSuccess,
  shouldShowApiErrorMsg,
} from '@/utils/orderStoreResponseHandler'
import { formatEmptyBucketIntentText } from '@/utils/bucketWaterOrder'
import { scheduleElTableFixedSync } from '@/utils/elTableFixedSync'

@Component({
  components: {
    HeadLable,
    InputAutoComplete,
    TabChange,
    Empty,
    UserNameRemark,
  },
})
export default class extends Vue {
  private defaultActivity: any = 0
  private orderStatics = {}
  private row: any = {}
  private isAutoNext = true
  private isTableOperateBtn = true
  private currentPageIndex = 0 //记录查看详情数据的index
  private orderId = '' //订单号
  private input = '' //搜索条件的订单号
  private phone = '' //搜索条件的手机号
  private valueTime = []
  private dialogVisible = false //详情弹窗
  private cancelDialogVisible = false //取消/退款弹窗
  private cancelDialogTitle = '' //取消/退款弹窗标题
  private refundPackageHint = false // 套餐单退款/取消时提示先退关联订水单
  private cancelReason = ''
  private remark = '' //自定义原因
  private currentStoreId: number | null = null // 当前操作订单的商户ID，用于退款等
  /** 赠送弹窗 */
  private giftDialogVisible = false
  private giftLoading = false
  private giftSubmitting = false
  private giftBucketsNum = 1
  private giftOrderId: any = null
  private giftStoreId: number | null = null
  private giftMode: 'current' | 'other' = 'other'
  private giftCanCurrent = false
  private giftCurrentDishId: number | null = null
  private giftDishId: number | null = null
  private giftDishLoading = false
  private giftDishOptions: Array<{
    id: number
    name: string
    image: string
    price: number
    categoryId?: number | null
    displayCategoryIds: number[]
  }> = []
  private giftAllCategoryFlat: any[] = []
  private giftDishCascaderOptions: any[] = []
  private giftDishCascaderProps = {
    value: 'value',
    label: 'label',
    children: 'children',
    emitPath: false,
    expandTrigger: 'hover' as const,
  }
  private giftPreview: any = {
    orderNumber: '',
    usedBuckets: 0,
    unusedBuckets: 0,
    giftedBuckets: 0,
    qtyUnit: '件',
    giftedUnit: '件',
    bucketWater: false,
    dishName: '',
    dishId: null,
    dishImage: '',
    dishPrice: null,
    goodsPieceCount: 0,
    goodsKindCount: 0,
    canGiftCurrent: false,
  }

  get giftSelectedDish() {
    if (this.giftMode === 'current') {
      if (!this.giftCanCurrent || this.giftCurrentDishId == null) return null
      const hit = this.giftDishOptions.find(
        (d) => Number(d.id) === Number(this.giftCurrentDishId)
      )
      if (hit) return hit
      return {
        id: this.giftCurrentDishId,
        name: this.giftPreview.dishName || '当前商品',
        image: this.giftPreview.dishImage || '',
        price: this.giftPreview.dishPrice != null ? Number(this.giftPreview.dishPrice) : NaN,
        displayCategoryIds: [],
      }
    }
    if (this.giftDishId == null) return null
    return this.giftDishOptions.find((d) => Number(d.id) === Number(this.giftDishId)) || null
  }

  get giftCurrentDisabledTip(): string {
    const kind = Number(this.giftPreview && this.giftPreview.goodsKindCount)
    const pieces = Number(this.giftPreview && this.giftPreview.goodsPieceCount)
    if (kind > 1 || (Number.isNaN(kind) && pieces > 1)) {
      return '订单含多种商品，请选择其他商品赠送'
    }
    return '无法识别当前可赠商品，请选择其他商品'
  }

  /** 套餐：接口返回已用/未用；非套餐后端固定 0 */
  get giftUsedBuckets(): number {
    const n = Number(this.giftPreview && this.giftPreview.usedBuckets)
    return Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0
  }

  get giftUnusedBuckets(): number {
    const n = Number(this.giftPreview && this.giftPreview.unusedBuckets)
    return Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0
  }

  /** 含子单赠送配送 + 特惠入账 */
  get giftGiftedBuckets(): number {
    const n = Number(this.giftPreview && this.giftPreview.giftedBuckets)
    return Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0
  }

  get giftGiftedBucketQty(): number {
    const p = this.giftPreview as any
    if (p && p.giftedBucketQty != null) {
      const n = Number(p.giftedBucketQty)
      return Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0
    }
    // 兼容旧接口：单单位时整段落到对应侧
    if (this.giftGiftedUnit === '桶') return this.giftGiftedBuckets
    return 0
  }

  get giftGiftedPieceQty(): number {
    const p = this.giftPreview as any
    if (p && p.giftedPieceQty != null) {
      const n = Number(p.giftedPieceQty)
      return Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0
    }
    if (this.giftGiftedUnit === '件') return this.giftGiftedBuckets
    return 0
  }

  /** 共赠送：X桶，Y件（放未用后面） */
  get giftGiftedSummary(): string {
    return `${this.giftGiftedBucketQty}桶，${this.giftGiftedPieceQty}件`
  }

  /** 共赠送单位：桶装水→桶，其它→件（兼容旧预览） */
  get giftGiftedUnit(): string {
    const u = this.giftPreview && this.giftPreview.giftedUnit
    return u === '桶' || u === '件' ? u : this.giftQtyUnit
  }

  /** 本次赠送数量单位：随所选商品变化 */
  get giftQtyUnit(): string {
    if (this.giftMode === 'current') {
      if (this.giftPreview && this.giftPreview.qtyUnit === '桶') return '桶'
      if (this.giftPreview && this.giftPreview.bucketWater === true) return '桶'
      if (this.giftPreview && this.giftPreview.bucketWater === false) return '件'
      return this.looksLikeBucketGiftName(this.giftPreview && this.giftPreview.dishName) ? '桶' : '件'
    }
    const d = this.giftSelectedDish
    if (!d) return '件'
    if ((d as any).bucketWater === true) return '桶'
    if ((d as any).bucketWater === false) return '件'
    if (this.isGiftDishUnderBucketCategory(d)) return '桶'
    return this.looksLikeBucketGiftName(d.name) ? '桶' : '件'
  }

  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private tableData = []
  /** 按当前页内容测算的列宽 */
  private colW: Record<string, number> = {
    number: 132,
    status: 88,
    consignee: 72,
    phone: 110,
    userPhone: 110,
    address: 160,
    orderTime: 145,
    cancelTime: 145,
    cancelReason: 100,
    deliveryTime: 145,
    estimatedDeliveryTime: 145,
    courier: 110,
    amount: 88,
    orderDishes: 130,
    remark: 110,
    operate: 220,
  }
  private measureCtx: CanvasRenderingContext2D | null = null
  private tableColKey = 0
  private diaForm = []
  private isSearch: boolean = false
  private orderStatus = 0 //列表字段展示所需订单状态,用于分页请求数据
  private dialogOrderStatus = 0 //弹窗所需订单状态，用于详情展示字段
  private cancelOrderReasonList = [
    {
      value: 1,
      label: '订单量较多，暂时无法接单',
    },
    {
      value: 2,
      label: '商品已销售完，暂时无法接单',
    },
    {
      value: 3,
      label: '餐厅已打烊，暂时无法接单',
    },
    {
      value: 0,
      label: '自定义原因',
    },
  ]

  private cancelrReasonList = [
    {
      value: 1,
      label: '订单量较多，暂时无法接单',
    },
    {
      value: 2,
      label: '商品已销售完，暂时无法接单',
    },
    {
      value: 3,
      label: '骑手不足无法配送',
    },
    {
      value: 4,
      label: '客户电话取消',
    },
    {
      value: 0,
      label: '自定义原因',
    },
  ]
  private orderList = [
    {
      label: '全部订单',
      value: 0,
    },
    {
      label: '待付款',
      value: 1,
    },
    {
      label: '待接单',
      value: 2,
    },
    {
      label: '待派送',
      value: 3,
    },
    {
      label: '派送中',
      value: 4,
    },
    {
      label: '已取消',
      value: 6,
    },
    {
      label: '已退款',
      value: 7,
    },
    {
      label: '已完成',
      value: 5,
    },
  ]

  canManualUploadShipping(order: any) {
    return checkCanManualUploadShipping(order)
  }

  displayOrderRemark(remark: string) {
    return formatOrderRemarkDisplay(remark) || '—'
  }

  get orderDishSubtotal(): string {
    return orderDishSubtotalFrom(this.diaForm)
  }

  get orderQuotaDiscount(): string {
    return orderQuotaDiscountFrom(this.diaForm)
  }

  get showOrderDiscount(): boolean {
    return hasOrderDiscount(this.diaForm)
  }

  get orderDiscountText(): string {
    return orderDiscountLabel(this.diaForm)
  }

  get emptyBucketIntentText(): string {
    return formatEmptyBucketIntentText(this.diaForm)
  }

  get storeDisplayName(): string {
    const form = this.diaForm as any
    if (!form) return '—'
    if (form.shopName) return form.shopName
    if (form.storeId != null) return `商户${form.storeId}`
    return '—'
  }

  get payMethodText(): string {
    return payMethodLabel((this.diaForm as any).payMethod, this.diaForm)
  }

  get showMixedPaySplit(): boolean {
    const form = this.diaForm as any
    if (!form) return false
    const balance = Number(form.balancePayAmount)
    const online = Number(form.onlinePayAmount)
    return Number.isFinite(balance) && balance > 0 && Number.isFinite(online) && online > 0
  }

  get onlinePayChannelName(): string {
    const form = this.diaForm as any
    const m = Number(form && form.payMethod)
    return m === 3 ? '支付宝支付' : '微信支付'
  }

  get currentCourierLabel(): string {
    return this.formatCourierCell(this.diaForm)
  }

  formatCourierCell(row: any): string {
    if (!row || !row.courierId) return '-'
    const name = row.courierName || '派送员'
    const phone = row.courierPhone || row.courierTelephone || ''
    return phone ? `${name}（${phone}）` : name
  }

  private measureText(text: string, bold = false): number {
    const raw = String(text || '')
    if (typeof document === 'undefined') {
      return raw.length * (bold ? 15 : 14)
    }
    if (!this.measureCtx) {
      const canvas = document.createElement('canvas')
      this.measureCtx = canvas.getContext('2d')
    }
    if (!this.measureCtx) {
      return raw.length * (bold ? 15 : 14)
    }
    const weight = bold ? 'bold ' : ''
    this.measureCtx.font = `${weight}14px Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif`
    return this.measureCtx.measureText(raw).width
  }

  /** 列宽至少能完整显示表头（加粗），再与本页内容取较大值 */
  private fitColWidth(
    label: string,
    values: Array<string | number | null | undefined>,
    min: number,
    max: number,
    pad = 40
  ): number {
    // 表头加粗更宽，且 el-table .cell 左右各约 10~12px
    let maxW = this.measureText(label, true)
    for (let i = 0; i < values.length; i++) {
      const v = values[i]
      const w = this.measureText(v == null ? '' : String(v), false)
      if (w > maxW) maxW = w
    }
    const headerFloor = Math.ceil(this.measureText(label, true) + pad)
    return Math.min(max, Math.max(min, headerFloor, Math.ceil(maxW + pad)))
  }

  /** 按本页单元格文案自适应列宽；商品/地址/备注用 min-width 吃剩余空间（适配约 1440 宽屏） */
  refreshColWidths() {
    const rows: any[] = this.tableData || []
    const compact = typeof window !== 'undefined' && window.innerWidth <= 1600
    this.colW = {
      number: this.fitColWidth(
        '订单号',
        rows.map((r) => {
          // 按最长一行估宽（主单号 / 赠送子单号），避免用拼接串把列撑得过宽
          let longest = String(r.number || '')
          ;(r.subOrderNumbers || []).forEach((n: string) => {
            const s = String(n || '')
            if (s.length > longest.length) longest = s
          })
          return longest
        }),
        compact ? 108 : 118,
        compact ? 140 : 152,
        28
      ),
      status: this.fitColWidth(
        '订单状态',
        rows.map((r) => this.getOrderType(r)),
        80,
        100
      ),
      consignee: this.fitColWidth(
        '用户名',
        rows.map((r) => {
          const name = r.consignee || r.userName || ''
          const remark = r.userRemark || ''
          return remark ? `${name}\n${remark}` : name
        }),
        64,
        compact ? 100 : 120
      ),
      phone: this.fitColWidth(
        '收货手机',
        rows.map((r) => r.phone),
        108,
        120
      ),
      userPhone: this.fitColWidth(
        '下单人手机号',
        rows.map((r) => r.userPhone || '—'),
        108,
        130
      ),
      // 长文本列：仅设下限，交给表格分配剩余宽度；展示规则不变（商品/备注两行，地址完整换行）
      address: compact ? 150 : 180,
      orderTime: this.fitColWidth(
        '下单时间',
        rows.map((r) => r.orderTime),
        135,
        155
      ),
      cancelTime: this.fitColWidth(
        '取消时间',
        rows.map((r) => r.cancelTime || '—'),
        135,
        155
      ),
      cancelReason: this.fitColWidth(
        '取消原因',
        rows.map((r) => r.cancelReason || r.rejectionReason || '—'),
        88,
        compact ? 140 : 180
      ),
      deliveryTime: this.fitColWidth(
        '送达时间',
        rows.map((r) => r.deliveryTime),
        135,
        155
      ),
      estimatedDeliveryTime: this.fitColWidth(
        '预计送达时间',
        rows.map((r) => r.estimatedDeliveryTime),
        120,
        155
      ),
      courier: this.fitColWidth(
        '派送员',
        rows.map((r) => {
          if (!r || !r.courierId) return '-'
          const name = r.courierName || '派送员'
          const phone = r.courierPhone || r.courierTelephone || ''
          return phone && this.measureText(phone) > this.measureText(name) ? phone : name
        }),
        72,
        compact ? 110 : 120
      ),
      amount: this.fitColWidth(
        '实收金额',
        rows.map((r) => `￥${this.formatOrderMoney(r.amount)}`),
        80,
        110
      ),
      orderDishes: compact ? 160 : 200,
      remark: compact ? 100 : 120,
      operate: this.estimateOperateColWidth(),
    }
    this.tableColKey += 1
    scheduleElTableFixedSync(this, 'orderTable')
  }

  /** 操作列：默认单行排下按钮；仅当列宽被压窄时才靠 CSS 折行 */
  private estimateOperateColWidth(): number {
    const st = this.orderStatus
    // 全部/已完成：退款+赠送+查看；其它：查看（或赠送+查看）
    if (st === 0 || st === 5) return 180
    return 120
  }

  formatOrderMoney(val: any) {
    return formatMoney(val)
  }

  dishLineAmount(item: any) {
    return dishLineTotal(item)
  }

  giftList(item: any) {
    const list = item && item.gifts
    return Array.isArray(list) ? list.filter(Boolean) : []
  }

  created() {
    const qStatus = Number(this.$route.query.status)
    const status = [0, 5, 6, 7].includes(qStatus) ? qStatus : 0
    this.init(status || 0)
  }

  mounted() {
    //如果有值说明是消息通知点击进来的
    if (
      this.$route.query.orderId &&
      this.$route.query.orderId !== 'undefined'
    ) {
      this.goDetail(this.$route.query.orderId)
    }
    const qStatus = Number(this.$route.query.status)
    this.defaultActivity = [0, 5, 6, 7].includes(qStatus) ? qStatus : 0
    window.addEventListener('resize', this.onViewportResize)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onViewportResize)
  }

  private resizeTimer: any = null
  onViewportResize() {
    if (this.resizeTimer) clearTimeout(this.resizeTimer)
    this.resizeTimer = setTimeout(() => {
      this.refreshColWidths()
    }, 150)
  }

  initFun(orderStatus) {
    this.page = 1
    this.init(orderStatus)
  }

  change(activeIndex) {
    if (activeIndex === this.orderStatus) return
    this.page = 1
    this.init(activeIndex)
    this.input = ''
    this.phone = ''
    this.valueTime = []
    this.dialogOrderStatus = 0
    this.$router.push('/order')
    console.log(activeIndex, '接收到了子组件的index')
  }

  init(activeIndex: number = 0, isSearch?) {
    this.isSearch = isSearch
    const tab = [0, 5, 6, 7].includes(Number(activeIndex)) ? Number(activeIndex) : 0
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      number: this.input || undefined,
      phone: this.phone || undefined,
      beginTime:
        this.valueTime && this.valueTime.length > 0
          ? this.valueTime[0]
          : undefined,
      endTime:
        this.valueTime && this.valueTime.length > 0
          ? this.valueTime[1]
          : undefined,
      status: tab || undefined,
      // 付款购单：终态 + 待派送/派送中（前端显示「已支付」）；额度/赠品派送仍在「派送记录」
      purchaseOnly: true,
    }
    getOrderDetailPage({ ...params })
      .then((res) => {
        if (isApiSuccess(res.data.code)) {
          const pageData = res.data.data || {}
          const records = pageData.records || []
          this.tableData = records
          this.orderStatus = tab
          this.counts = Number(pageData.total) || 0
          this.refreshColWidths()
        } else {
          this.tableData = []
          this.counts = 0
          if (shouldShowApiErrorMsg(res.data)) {
            this.$message.error(res.data.msg)
          }
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  getOrderType(row: any) {
    return this.formatOrderManageStatus(row && row.status)
  }

  /** 订单管理状态文案：进行中付款单显示「已支付」 */
  formatOrderManageStatus(status: any) {
    const st = Number(status)
    if (st === 1) return '待付款'
    if (st === 2) return '待接单'
    if (st === 3 || st === 4) return '已支付'
    if (st === 5) return '已完成'
    if (st === 6) return '已取消'
    if (st === 7) return '已退款'
    return '—'
  }

  get dialogStatusLabel() {
    return this.formatOrderManageStatus(this.dialogOrderStatus)
  }

  /** 业务类型：商品 / 实惠套餐 / 特惠套餐；混合单按明细拼接 */
  formatOrderBizType(row: any) {
    return resolveOrderBizType(row)
  }

  /** 主单赠送提示：2026-09-23 12:05 赠送 2 桶 */
  formatAdminGiftLog(log: any): string {
    if (!log) return ''
    const qty = Number(log.giftQty)
    const unit = (log.unit && String(log.unit).trim()) || '桶'
    const qtyText = Number.isFinite(qty) && qty > 0 ? `${Math.floor(qty)} ${unit}` : `— ${unit}`
    let timeText = ''
    const t = log.giftTime
    if (t != null) {
      if (typeof t === 'string') {
        timeText = t.length >= 16 ? t.slice(0, 16).replace('T', ' ') : t.replace('T', ' ')
      } else if (Array.isArray(t) && t.length >= 5) {
        const pad = (n: number) => (n < 10 ? `0${n}` : String(n))
        timeText = `${t[0]}-${pad(t[1])}-${pad(t[2])} ${pad(t[3])}:${pad(t[4])}`
      } else {
        try {
          const d = new Date(t)
          if (!Number.isNaN(d.getTime())) {
            const pad = (n: number) => (n < 10 ? `0${n}` : String(n))
            timeText = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
          }
        } catch (e) {
          /* ignore */
        }
      }
    }
    const name = log.dishName ? `（${log.dishName}）` : ''
    return timeText ? `${timeText} 赠送 ${qtyText}${name}` : `赠送 ${qtyText}${name}`
  }

  // 查看详情
  async goDetail(id: any, status?: number, row?: any) {
    // console.log(111, index, row)
    this.diaForm = []
    this.dialogVisible = true
    this.orderId = id
    const { data } = await queryOrderDetailById({ orderId: id })
    const orderData = data.data || {}
    this.diaForm = orderData
    const realStatus = orderData.status != null
      ? orderData.status
      : (status != null ? status : 0)
    this.dialogOrderStatus = realStatus
    const baseRow = row || { id: this.$route.query.orderId }
    this.row = {
      ...baseRow,
      id: orderData.id != null ? orderData.id : id,
      status: realStatus,
      storeId: orderData.storeId != null ? orderData.storeId : baseRow.storeId,
      courierId: orderData.courierId != null ? orderData.courierId : baseRow.courierId,
    }
    const rowStoreId = this.row && this.row.storeId != null ? this.row.storeId : null
    const dataStoreId = orderData && orderData.storeId != null ? orderData.storeId : null
    this.currentStoreId = rowStoreId || dataStoreId || null
    if (this.$route.query.orderId) {
      this.$router.push('/order')
    }
  }

  // 打开退款弹窗（复用取消接口：后端 cancel 在已支付时会触发退款）
  refundOrder(row: any) {
    this.cancelDialogVisible = true
    this.orderId = row.id
    const rStoreId = row && row.storeId != null ? row.storeId : null
    const fStoreId = this.diaForm && (this.diaForm as any).storeId != null ? (this.diaForm as any).storeId : null
    this.currentStoreId = rStoreId != null ? rStoreId : fStoreId
    this.dialogOrderStatus = row.status
    this.cancelDialogTitle = '退款'
    this.refundPackageHint = this.isPackagePurchaseOrder(row)
    this.dialogVisible = false
    this.cancelReason = ''
  }

  /** 实惠/特惠套餐购买单（非普通订水） */
  private isPackagePurchaseOrder(row: any): boolean {
    if (!row) return false
    const t = row.orderType != null ? Number(row.orderType) : NaN
    if (t === 3 || t === 4) return true
    const label = this.formatOrderBizType(row) || ''
    return label.indexOf('实惠') >= 0 || label.indexOf('特惠') >= 0
  }

  /** 已支付、未完成/未取消/未退款的付款购单可退款（含待派送/派送中，列表显示「已支付」） */
  canRefundOrder(row: any): boolean {
    if (!row || row.id == null) return false
    if (Number(row.payStatus) !== 1) return false
    const st = Number(row.status)
    if (st === 6 || st === 7) return false
    if (st !== 3 && st !== 4 && st !== 5) return false
    if (isNonPaymentFulfillmentOrder(row)) return false
    return true
  }

  /** 已支付且未取消/退款的主订单可赠送；水券/赠品配送、赠送入账单不可再赠 */
  canGiftBuckets(row: any): boolean {
    if (!row || row.id == null) return false
    if (Number(row.payStatus) !== 1) return false
    const st = Number(row.status)
    if (st === 6 || st === 7) return false
    if (isNonPaymentFulfillmentOrder(row)) return false
    return true
  }

  async openGiftBuckets(row: any) {
    if (!row || row.id == null) return
    if (!this.canGiftBuckets(row)) {
      this.$message.warning('赠送订单不可再次赠送，请从主订单操作')
      return
    }
    this.giftOrderId = row.id
    this.giftStoreId = row.storeId != null ? Number(row.storeId) : this.currentStoreId
    this.giftBucketsNum = 1
    this.giftDishId = null
    this.giftCurrentDishId = null
    this.giftCanCurrent = false
    this.giftMode = 'other'
    this.giftPreview = {
      orderNumber: row.number || '',
      usedBuckets: 0,
      unusedBuckets: 0,
      dishName: '',
      dishId: null,
      dishImage: '',
      dishPrice: null,
    goodsPieceCount: 0,
    goodsKindCount: 0,
    canGiftCurrent: false,
    }
    this.giftDialogVisible = true
    this.giftLoading = true
    try {
      await Promise.all([
        this.reloadGiftPreview(),
        this.loadGiftDishOptions(this.giftStoreId),
      ])
      if (this.giftCanCurrent) {
        this.giftMode = 'current'
        this.giftDishId = this.giftCurrentDishId
      } else {
        this.giftMode = 'other'
        this.giftDishId = null
      }
    } catch (e: any) {
      this.$message.error((e && e.message) || '加载赠送信息失败')
      this.giftDialogVisible = false
    } finally {
      this.giftLoading = false
    }
  }

  /** 刷新弹窗已用/未用（含后台赠送合并后的总量） */
  async reloadGiftPreview() {
    if (this.giftOrderId == null) return
    const params: any = { orderId: this.giftOrderId }
    if (this.giftStoreId != null) params.storeId = this.giftStoreId
    const res: any = await giftBucketsPreview(params)
    if (res && res.data && res.data.code === 1 && res.data.data) {
      this.giftPreview = res.data.data
      this.giftCanCurrent = !!this.giftPreview.canGiftCurrent && this.giftPreview.dishId != null
      this.giftCurrentDishId = this.giftCanCurrent ? Number(this.giftPreview.dishId) : null
      if (this.giftCanCurrent && this.giftMode === 'current') {
        this.giftDishId = this.giftCurrentDishId
      } else if (!this.giftCanCurrent) {
        this.giftMode = 'other'
        if (Number(this.giftDishId) === Number(this.giftCurrentDishId)) {
          this.giftDishId = null
        }
      }
    } else {
      throw new Error((res && res.data && res.data.msg) || '加载赠送信息失败')
    }
  }

  onGiftModeChange() {
    if (this.giftMode === 'current') {
      this.giftDishId = this.giftCurrentDishId
    } else if (this.giftMode === 'other' && Number(this.giftDishId) === Number(this.giftCurrentDishId)) {
      this.giftDishId = null
    }
  }

  private getCategoryParentId(c: any): number | null {
    if (!c) return null
    const pid = c.parentId != null ? c.parentId : c.parent_id
    if (pid == null || pid === '' || Number(pid) === 0) return null
    const n = Number(pid)
    return Number.isNaN(n) ? null : n
  }

  private rebuildGiftDishCascaderTree() {
    const nodes: Record<string, any> = {}
    ;(this.giftAllCategoryFlat || []).forEach((c: any) => {
      if (!c || c.id == null) return
      nodes[String(c.id)] = {
        value: `c-${c.id}`,
        label: c.name || `分类#${c.id}`,
        children: [] as any[],
        _parentId: this.getCategoryParentId(c),
      }
    })
    const uncategorized: any[] = []
    this.giftDishOptions.forEach((d) => {
      const priceText =
        d.price != null && Number.isFinite(Number(d.price))
          ? `（￥${Number(d.price).toFixed(2)}）`
          : ''
      const leaf = {
        value: Number(d.id),
        label: `${d.name || '商品'}${priceText}`,
      }
      const ids = Array.isArray(d.displayCategoryIds) ? d.displayCategoryIds : []
      let mounted = false
      ids.forEach((cid) => {
        if (cid == null) return
        const node = nodes[String(cid)]
        if (!node) return
        if (!node.children.some((c: any) => Number(c.value) === leaf.value)) {
          node.children.push({ ...leaf })
        }
        mounted = true
      })
      if (!mounted) uncategorized.push(leaf)
    })
    const roots: any[] = []
    Object.keys(nodes).forEach((key) => {
      const node = nodes[key]
      const pid = node._parentId
      delete node._parentId
      if (pid != null && nodes[String(pid)]) {
        nodes[String(pid)].children.push(node)
      } else {
        roots.push(node)
      }
    })
    const sortAndPrune = (list: any[]): any[] => {
      const next = (list || [])
        .map((n) => {
          if (n == null) return null
          if (typeof n.value === 'number') return n
          const kids = sortAndPrune(n.children || [])
          if (!kids.length) return null
          return { ...n, children: kids }
        })
        .filter(Boolean) as any[]
      next.sort((a, b) => {
        const aLeaf = typeof a.value === 'number' ? 1 : 0
        const bLeaf = typeof b.value === 'number' ? 1 : 0
        if (aLeaf !== bLeaf) return aLeaf - bLeaf
        return String(a.label).localeCompare(String(b.label), 'zh-CN')
      })
      return next
    }
    const tree = sortAndPrune(roots)
    if (uncategorized.length) {
      uncategorized.sort((a, b) =>
        String(a.label).localeCompare(String(b.label), 'zh-CN')
      )
      tree.push({ value: 'c-uncategorized', label: '未分类', children: uncategorized })
    }
    this.giftDishCascaderOptions = tree
  }

  private async loadGiftDishOptions(storeId: number | null) {
    if (storeId == null) {
      this.giftDishOptions = []
      this.giftDishCascaderOptions = []
      this.giftAllCategoryFlat = []
      return
    }
    this.giftDishLoading = true
    try {
      const [catRes, dishRes]: any[] = await Promise.all([
        getCategoryList({ storeId, type: 1 }),
        queryDishList({ storeId }),
      ])
      const cats =
        String(catRes.data.code) === '1' && Array.isArray(catRes.data.data)
          ? catRes.data.data
          : []
      this.giftAllCategoryFlat = cats
      const list =
        String(dishRes.data.code) === '1' && Array.isArray(dishRes.data.data)
          ? dishRes.data.data
          : []
      this.giftDishOptions = list
        .filter((d: any) => d && d.id != null)
        .map((d: any) => ({
          id: Number(d.id),
          name: d.name || `商品#${d.id}`,
          image: d.image || '',
          price: d.price != null ? Number(d.price) : NaN,
          categoryId: d.categoryId != null ? Number(d.categoryId) : null,
          displayCategoryIds: Array.isArray(d.displayCategoryIds)
            ? d.displayCategoryIds
                .map((id: any) => Number(id))
                .filter((id: number) => !Number.isNaN(id))
            : [],
        }))
      this.rebuildGiftDishCascaderTree()
    } catch (e) {
      this.giftDishOptions = []
      this.giftDishCascaderOptions = []
      this.giftAllCategoryFlat = []
    } finally {
      this.giftDishLoading = false
    }
  }

  /** 分类树是否落在「桶装水」下 */
  private isGiftDishUnderBucketCategory(dish: any): boolean {
    if (!dish) return false
    const ids: number[] = []
    if (dish.categoryId != null && !Number.isNaN(Number(dish.categoryId))) {
      ids.push(Number(dish.categoryId))
    }
    ;(dish.displayCategoryIds || []).forEach((id: any) => {
      const n = Number(id)
      if (!Number.isNaN(n)) ids.push(n)
    })
    if (!ids.length || !this.giftAllCategoryFlat || !this.giftAllCategoryFlat.length) return false
    const byId: Record<string, any> = {}
    this.giftAllCategoryFlat.forEach((c: any) => {
      if (c && c.id != null) byId[String(c.id)] = c
    })
    const isBucketName = (name: string) => {
      const n = String(name || '')
      return n.indexOf('桶装水') >= 0 || n.indexOf('桶装') >= 0
    }
    for (let i = 0; i < ids.length; i++) {
      let cur = byId[String(ids[i])]
      let guard = 0
      while (cur && guard < 8) {
        if (isBucketName(cur.name)) return true
        const pid = cur.parentId != null ? cur.parentId : cur.parent_id
        if (pid == null || Number(pid) === 0) break
        cur = byId[String(pid)]
        guard++
      }
    }
    return false
  }

  private looksLikeBucketGiftName(name: any): boolean {
    const n = String(name || '').trim()
    if (!n) return false
    if (/空桶/.test(n)) return false
    if (/桶装水|饮用水|矿泉水|纯净水|山泉水|泉水/.test(n)) return true
    return n.indexOf('桶') >= 0
  }

  resetGiftDialog() {
    this.giftBucketsNum = 1
    this.giftOrderId = null
    this.giftStoreId = null
    this.giftDishId = null
    this.giftCurrentDishId = null
    this.giftCanCurrent = false
    this.giftMode = 'other'
    this.giftSubmitting = false
    this.giftLoading = false
    this.giftPreview = {
      orderNumber: '',
      usedBuckets: 0,
      unusedBuckets: 0,
      dishName: '',
      dishId: null,
      dishImage: '',
      dishPrice: null,
    goodsPieceCount: 0,
    goodsKindCount: 0,
    canGiftCurrent: false,
    }
  }

  async confirmGiftBuckets() {
    if (this.giftSubmitting) return
    if (this.giftOrderId == null) {
      this.$message.error('订单无效')
      return
    }
    let dishId: number | null = null
    if (this.giftMode === 'current') {
      if (!this.giftCanCurrent || this.giftCurrentDishId == null) {
        this.$message.warning('当前订单含多种商品，请选择其他商品赠送')
        return
      }
      dishId = this.giftCurrentDishId
    } else {
      dishId = this.giftDishId
      if (dishId == null) {
        this.$message.warning('请选择赠送商品')
        return
      }
    }
    const n = Number(this.giftBucketsNum)
    if (!Number.isFinite(n) || n <= 0 || Math.floor(n) !== n) {
      this.$message.warning('请输入正整数数量')
      return
    }
    if (n > 99) {
      this.$message.warning('单次赠送不能超过99件')
      return
    }
    this.giftSubmitting = true
    try {
      const payload: any = {
        orderId: this.giftOrderId,
        dishId,
        giftBuckets: n,
      }
      if (this.giftStoreId != null) payload.storeId = this.giftStoreId
      const res: any = await giftBucketsCreate(payload)
      if (res && res.data && res.data.code === 1) {
        const vo = res.data.data || {}
        this.$message.success(vo.message || '赠送成功，已入账')
        this.giftDialogVisible = false
        this.giftBucketsNum = 1
        this.init(this.orderStatus)
      } else {
        this.$message.error((res && res.data && res.data.msg) || '赠送失败')
      }
    } catch (e: any) {
      this.$message.error((e && e.message) || '赠送失败')
    } finally {
      this.giftSubmitting = false
    }
  }

  //确认取消或拒绝订单并填写原因
  confirmCancel(type) {
    if (!this.cancelReason) {
      return this.$message.error(`请选择${this.cancelDialogTitle}原因`)
    } else if (this.cancelReason === '自定义原因' && !this.remark) {
      return this.$message.error(`请输入${this.cancelDialogTitle}原因`)
    }

    const isCancel = this.cancelDialogTitle === '取消'
    const isRefund = this.cancelDialogTitle === '退款'
    const storeId = this.currentStoreId != null ? this.currentStoreId : (this.diaForm && (this.diaForm as any).storeId != null ? (this.diaForm as any).storeId : undefined)
    const action = isRefund ? orderRefund : (isCancel ? orderCancel : orderReject)
    ;(action as any)({
      id: this.orderId,
      storeId,
      // eslint-disable-next-line standard/computed-property-even-spacing
      [isCancel || isRefund ? 'cancelReason' : 'rejectionReason']:
        this.cancelReason === '自定义原因' ? this.remark : this.cancelReason,
    })
      .then((res) => {
        if (res.data.code === 1) {
          this.$message.success('操作成功')
          this.cancelDialogVisible = false
          this.orderId = ''
          // this.dialogOrderStatus = 0
          this.init(this.orderStatus)
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  // 手动补偿上传微信发货信息
  manualUploadShipping(id: number | string) {
    if (!id) return
    uploadShippingRetry(id)
      .then((res) => {
        if (res.data.code === 1) {
          this.$message.success('补发货请求已提交')
        } else {
          this.$message.error(res.data.msg || '补发货失败')
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  handleClose() {
    this.dialogVisible = false
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init(this.orderStatus)
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init(this.orderStatus)
  }
}
